import TrashCanIconPath from "@ingka/ssr-icon/paths/trash-can";

export default TrashCanIconPath;
